<template>
  <div class="banner">
    <div class="title">{{ chineseExperimentName === 0 ? experimentSetupArray01[experimentSetup] : experimentSetupArray02[experimentSetup] }}</div>
    <div class="itemBox">
      <div class="item funnel01" v-if="chineseExperimentName === 0">
        <img
          v-show="experimentSetup < 2"
          data-steps="2"
          ref="clampDom"
          class="cupImg"
          data-className="cupImg"
          src="../assets/img/experiment/clamp.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item paper01" v-if="chineseExperimentName === 0">
        <img
          v-show="experimentSetup < 3"
          data-steps="3"
          class="funnelImg"
          data-className="funnelImg"
          src="../assets/img/experiment/paper.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item cardboard01" v-if="chineseExperimentName === 0">
        <img
          v-show="experimentSetup < 1"
          data-steps="1"
          class="cardboardImg"
          data-className="cardboardImg"
          src="../assets/img/experiment/cardboard.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item soil01" ref="soilDom" v-if="chineseExperimentName === 0">
        <img
          src="../assets/img/experiment/ruler.png"
          v-show="experimentSetup < 4"
          data-steps="4"
          class="filterImg"
          data-className="filterImg"
          @mousedown="startMoveFuntion"
          alt=""
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item cup01" ref="cup" v-if="chineseExperimentName === 0">
        <img
          src="../assets/img/experiment/cup.png"
          v-show="experimentSetup < 5"
          data-steps="5"
          class="soilImg"
          data-className="soilImg"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item funnel02" v-if="chineseExperimentName === 1">
        <img
          v-show="experimentSetup < 2"
          data-steps="2"
          ref="clampDom"
          class="cupImg"
          data-className="cupImg"
          src="../assets/img/experiment/clamp.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item paper02" v-if="chineseExperimentName === 1">
        <img
          v-show="experimentSetup < 3"
          data-steps="3"
          class="funnelImg"
          data-className="funnelImg"
          src="../assets/img/experiment/paper.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item cardboard02" v-if="chineseExperimentName === 1">
        <img
          v-show="experimentSetup < 1"
          data-steps="1"
          class="cardboardImg"
          data-className="cardboardImg"
          src="../assets/img/experiment/cardboard.png"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item soil02" ref="soilDom" v-if="chineseExperimentName === 1">
        <img
          src="../assets/img/experiment/ruler.png"
          v-show="experimentSetup < 5"
          data-steps="5"
          class="soilImg"
          data-className="soilImg"
          @mousedown="startMoveFuntion"
          alt=""
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item cup02" ref="cup" v-if="chineseExperimentName === 1">
        <img
          src="../assets/img/experiment/cup.png"
          v-show="experimentSetup < 6"
          data-steps="6"
          class="glassImg"
          data-className="glassImg"
          alt=""
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
      <div class="item facemask02" v-if="chineseExperimentName === 1">
        <img
          src="../assets/img/experiment/facemask.png"
          alt=""
          v-show="experimentSetup < 4"
          data-steps="4"
          class="filterImg"
          data-className="filterImg"
          @mousedown="startMoveFuntion"
          @touchstart="startMoveFuntion"
        />
      </div>
    </div>
    <img :src="checkBtnPicture" alt="" class="checkBtn" v-show="waterShow" @mouseenter="changeCheck" @mouseleave="changeCheckActive" @click="backFather" />
    <div class="experimentBox">
      <img :src="imageMap[experimentSetup + clampNumber]" class="frame" />
      <div class="cupHeadBox">
        <img
          :src="clickBtn"
          alt=""
          v-show="(experimentSetup === 6 && chineseExperimentName === 0) || (experimentSetup === 7 && chineseExperimentName === 1)"
          @mouseenter="clickBtnActive"
          @mouseleave="clickBtnFunction"
          @click="nextSetup"
          style="position: absolute; width: 8vw; top: 21vh; left: 22.3vw"
        />
      </div>
      <div class="cupAll">
        <div class="cupHeadBox" style="position: absolute; bottom: 1vh; right: 0; text-align: center">
          <img
            src="../assets/img/experiment/cupHead.png"
            alt=""
            v-show="(experimentSetup > 4 && chineseExperimentName === 0) || (experimentSetup > 5 && chineseExperimentName === 1)"
            ref="cupHeadDom"
            style="width: 2vw; position: absolute; top: 0; left: 30%"
            @click="nextSetup"
          />
          <img src="../assets/img/experiment/cupBody.png" alt="" style="width: 4.5vw; visibility: hidden" />
        </div>
        <img
          src="../assets/img/experiment/cupBody.png"
          alt=""
          style="position: absolute; bottom: 0vh; right: 0vw; z-index: 1; width: 4.5vw"
          v-show="(experimentSetup > 4 && chineseExperimentName === 0) || (experimentSetup > 5 && chineseExperimentName === 1)"
        />
        <img src="../assets/img/experiment/spray.png" alt="" v-show="choseNow === false" style="position: absolute; bottom: 9vw; left: 4vw; width: 33vw" />
      </div>
    </div>
    <!-- 指示箭头 -->
    <img src="../assets/img/experiment/箭头.gif" alt="" class="arrow" ref="arrow01" v-show="experimentSetup < 5 && chineseExperimentName === 0" />
    <img src="../assets/img/experiment/箭头.gif" alt="" class="arrow" ref="arrow02" v-show="experimentSetup < 6 && chineseExperimentName === 1" />
    <img :src="waterValueImg" alt="" v-show="waterShow" class="waterPicture" />
    <img :src="sumbitBtn" alt="" class="showMask" @click="showWater" @mouseenter="submitBtnActive" @mouseleave="submitBtn" v-show="experimentSetup == 7 && chineseExperimentName === 0" />
    <div class="messageBox" v-show="experimentSetup == 5 && chineseExperimentName === 0">為確保是公平測試，每次噴水瓶的距離和按壓的次數要一樣。</div>
    <img src="../assets/img/index/机器人.gif" alt="" class="robot" v-show="experimentSetup == 5 && chineseExperimentName === 0" />
    <img :src="sumbitBtn" alt="" class="showMask" @click="showWater" @mouseenter="submitBtnActive" @mouseleave="submitBtn" v-show="experimentSetup == 8 && chineseExperimentName === 1" />
    <div class="messageBox" v-show="experimentSetup == 6 && chineseExperimentName === 1">為確保是公平測試，每次噴水瓶的距離和按壓的次數要一樣。</div>
    <img src="../assets/img/index/机器人.gif" alt="" class="robot" v-show="experimentSetup == 6 && chineseExperimentName === 1" />
  </div>
  <img :src="homeBtnImg" alt="" class="homeBtn" @mouseenter="homeBtnActive" @mouseleave="homeBtn" @click="homeBack" />
  <audio ref="audioPlay" :loop="false">
    <source :src="oneAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayTwo" :loop="false">
    <source :src="twoAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayThree" :loop="false">
    <source :src="threeAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayFour" :loop="false">
    <source :src="fourAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayFive" :loop="false">
    <source :src="fiveAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlaySix" :loop="false">
    <source :src="sixAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlaySeven" :loop="false">
    <source :src="sevenAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayEight" :loop="false">
    <source :src="eightAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayNine" :loop="false">
    <source :src="nineAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayTen" :loop="false">
    <source :src="tenAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayEleven" :loop="false">
    <source :src="elevenAudio" type="audio/mpeg" />
  </audio>
  <audio ref="audioPlayTwelve" :loop="false">
    <source :src="twelveAudio" type="audio/mpeg" />
  </audio>
</template>
<script setup>
import { defineProps, defineEmits, onMounted, ref, onUnmounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import anime from "animejs";
import setups00 from "../assets/img/experiment/setups00.png";
import setups01 from "../assets/img/experiment/setups01.png";
import setups02 from "../assets/img/experiment/setups02.png";
import setups03 from "../assets/img/experiment/setups03.png";
import setups04 from "../assets/img/experiment/setups04.png";
import setups05 from "../assets/img/experiment/setups05.png";
import setups06 from "../assets/img/experiment/setups06.png";
import setups07 from "../assets/img/experiment/setups07.png";
import setups08 from "../assets/img/experiment/setups08.png";
import setups09 from "../assets/img/experiment/setups09.png";
import setups10 from "../assets/img/experiment/setups10.png";
import setups11 from "../assets/img/experiment/setups11.png";
import setups12 from "../assets/img/experiment/setups12.png";
import setups13 from "../assets/img/experiment/setups13.png";
import setups14 from "../assets/img/experiment/setups14.png";
import setups15 from "../assets/img/experiment/setups15.png";
import cheackBtnActive from "../assets/img/reason/submitBtnActive.png";
import cheackBtn from "../assets/img/reason/submitBtn.png";
import waterBackground01 from "../assets/img/experiment/waterBackground01.jpg";
import waterBackground02 from "../assets/img/experiment/waterBackground02.jpg";

// 音频导入
import oneAudio from "../assets/audio/interaction/oneAudio.mp3";
import twoAudio from "../assets/audio/interaction/twoAudio.mp3";
import threeAudio from "../assets/audio/interaction/threeAudio.mp3";
import fourAudio from "../assets/audio/interaction/fourAudio.mp3";
import fiveAudio from "../assets/audio/interaction/fiveAudio.mp3";
import sixAudio from "../assets/audio/interaction/sixAudio.mp3";
import sevenAudio from "../assets/audio/interaction/sevenAudio.mp3";
import eightAudio from "../assets/audio/interaction/eightAudio.mp3";
import nineAudio from "../assets/audio/interaction/nineAudio.mp3";
import tenAudio from "../assets/audio/interaction/tenAudio.mp3";
import elevenAudio from "../assets/audio/interaction/elevenAudio.mp3";
import twelveAudio from "../assets/audio/interaction/twelveAudio.mp3";

let audioPlay = ref();
let audioPlayTwo = ref();
let audioPlayThree = ref();
let audioPlayFour = ref();
let audioPlayFive = ref();
let audioPlaySix = ref();
let audioPlaySeven = ref();
let audioPlayEight = ref();
let audioPlayNine = ref();
let audioPlayTen = ref();
let audioPlayEleven = ref();
let audioPlayTwelve = ref();

import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";

import sumbitBtnImg from "../assets/img/experiment/observeBtn.png";
import sumbitBtnActiveImg from "../assets/img/experiment/observeBtnActive.png";

import clickBtnImg from "../assets/img/experiment/clickBtn.png";
import clickBtnActiveImg from "../assets/img/experiment/clickBtnActive.png";
import router from "@/router";

// 高亮切换
let homeBtnImg = ref(home);
// 首页按钮切换
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};

// 高亮切换
let sumbitBtn = ref(sumbitBtnImg);
// 首页按钮切换
const submitBtnActive = () => {
  sumbitBtn.value = sumbitBtnActiveImg;
};
const submitBtn = () => {
  sumbitBtn.value = sumbitBtnImg;
};

// 点击切换
let clickBtn = ref(clickBtnImg);
// 首页按钮切换
const clickBtnActive = () => {
  clickBtn.value = clickBtnActiveImg;
};
const clickBtnFunction = () => {
  clickBtn.value = clickBtnImg;
};

// 当前是否进行拖拽
let isDragging = ref(false);
let offsetX = ref(0);
let offsetY = ref(0);

// 记录水量
let saveWater = ref(null);
// 显示弹窗
let maskShow = ref(false);
// 显示水量
let waterShow = ref(false);
// 水量实景显示
let waterValueImg = ref(waterBackground01);
// 沙子添加顯示
let weighSoilAddImg = ref("");
// 当前进行实验 中文
let chineseExperimentName = ref("");
// 当前进行步骤
let experimentSetup = ref(0);
// 當前夾子數量
let clampNumber = ref(0);
// 是否進行按压
let choseNow = ref(0);
// 当前进行步骤的class名
let experimentClassName = ref("");
// 箭头节点
let arrow01 = ref("");
let arrow02 = ref("");
// 土壤节点
let soilDom = ref(null);
// 實驗土壤節點
let weighSoil = ref(null);
// 夾子節點
let clampDom = ref(null);
// 瓶子头部节点
let cupHeadDom = ref(null);
let experimentSetupArray01 = [
  "Step1：拖放卡紙到合適位置。",
  "Step2：拖放四個夾子到合適位置。",
  "Step3：將白紙拖放到合適位置。",
  "Step4：用間尺量度好距離。",
  "Step5：放置有顏色溶液的噴水瓶。",
  "Step6：按壓噴水瓶，測試沒有口罩阻隔下，飛沫的噴濺結果。",
  "Step6：按壓噴水瓶，測試沒有口罩阻隔下，飛沫的噴濺結果。",
  "Step6：按壓噴水瓶，測試沒有口罩阻隔下，飛沫的噴濺結果。",
  "Step6：按壓噴水瓶，測試沒有口罩阻隔下，飛沫的噴濺結果。",
];
let experimentSetupArray02 = [
  "Step1：拖放卡紙到合適位置。",
  "Step2：拖放四個夾子到合適位置。",
  "Step3：將白紙拖放到合適位置。",
  "Step4：將口罩套在白紙上。",
  "Step5：用間尺量度好距離。",
  "Step6：放置有顏色溶液的噴水瓶。",
  "Step7：按壓噴水瓶，測試有口罩阻隔下，飛沫的噴濺結果。",
  "Step7：按壓噴水瓶，測試有口罩阻隔下，飛沫的噴濺結果。",
  "Step7：按壓噴水瓶，測試有口罩阻隔下，飛沫的噴濺結果。",
  "Step7：按壓噴水瓶，測試有口罩阻隔下，飛沫的噴濺結果。",
];
// 跟隨步驟同步更改图片地址
const imageMap = [setups00, setups01, setups02, setups03, setups04, setups05, setups06, setups07, setups08, setups09, setups10, setups11, setups12, setups13, setups14, setups15];
const minTime = ref(1);
const secTime = ref(59);
const timer = ref(null);
const porps = defineProps({
  experimentIndex: null,
});
// 查询按钮高亮显示地址
let checkBtnPicture = ref(cheackBtn);
const emit = defineEmits(["callMethod"]);
// 返回
const backFather = () => {
  emit("callMethod", false, 30);
};
// 初始化页面函数
const initPage = () => {
  // 0為未帶口罩時，反之
  if (porps.experimentIndex == 0) {
    chineseExperimentName.value = 0;
    waterValueImg.value = waterBackground01;
  } else if (porps.experimentIndex == 1) {
    chineseExperimentName.value = 1;
    waterValueImg.value = waterBackground02;
  }
};
// 物品拖入
const mouseEnterFunction = () => {
  if (experimentSetup.value === 0) {
    experimentSetup.value++;
    arrow01.value.style.left = "82vw";
    arrow01.value.style.top = "27vh";
    arrow02.value.style.left = "82vw";
    arrow02.value.style.top = "27vh";
    clearTimeout(timer.value);
    audioPlaySeven.value.pause();
    audioPlayNine.value.pause();
    audioPlay.value.play();
    return;
  }
  if (experimentSetup.value === 1 && clampNumber.value != 3) {
    clampNumber.value++;
    clampDom.value.style.left = "8.5vw";
    clampDom.value.style.top = chineseExperimentName.value === 0 ? "32vh" : "48.5vh";
    switch (clampNumber.value) {
      case 1:
        arrow01.value.style.left = "80vw";
        arrow01.value.style.top = "40vh";
        arrow02.value.style.left = "80vw";
        arrow02.value.style.top = "40vh";
        break;
      case 2:
        arrow01.value.style.left = "60vw";
        arrow01.value.style.top = "21vh";
        arrow02.value.style.left = "60vw";
        arrow02.value.style.top = "21vh";
        break;
      case 3:
        arrow01.value.style.left = "59vw";
        arrow01.value.style.top = "34vh";
        arrow02.value.style.left = "59vw";
        arrow02.value.style.top = "34vh";
        break;
    }
    return;
  }
  experimentSetup.value++;
  if (clampNumber.value == 3 && experimentSetup.value == 4 && chineseExperimentName.value == 1) {
    clampNumber.value += 4;
  }
  if (chineseExperimentName.value === 0) {
    // 根据步骤切换箭头位置
    switch (experimentSetup.value) {
      case 2:
        arrow01.value.style.left = "69.5vw";
        arrow01.value.style.top = "20vh";
        audioPlayFour.value.play();
        break;
      case 3:
        arrow01.value.style.left = "64vw";
        arrow01.value.style.top = "48vh";
        audioPlayThree.value.pause();
        audioPlayFour.value.pause();
        audioPlayTwo.value.play();
        break;
      case 4:
        arrow01.value.style.left = "52vw";
        arrow01.value.style.top = "30vh";
        audioPlayTwo.value.pause();
        audioPlayEleven.value.play();
        break;
    }
  } else if (chineseExperimentName.value === 1) {
    // 根据步骤切换箭头位置
    switch (experimentSetup.value) {
      case 2:
        arrow02.value.style.left = "69.5vw";
        arrow02.value.style.top = "20vh";
        audioPlayFour.value.play();
        break;
      case 3:
        arrow02.value.style.left = "70vw";
        arrow02.value.style.top = "24vh";
        audioPlayFour.value.pause();
        audioPlayThree.value.play();
        break;
      case 4:
        arrow02.value.style.left = "64vw";
        arrow02.value.style.top = "48vh";
        audioPlayThree.value.pause();
        audioPlayFour.value.pause();
        audioPlayTwo.value.play();
        break;
      case 5:
        arrow02.value.style.left = "52vw";
        arrow02.value.style.top = "30vh";
        audioPlayTwo.value.pause();
        audioPlayEleven.value.play();
        break;
    }
  }
  if (experimentSetup.value == 5 && chineseExperimentName.value === 0) {
    audioPlayEleven.value.pause();
    audioPlayFive.value.play();
    choseNow.value = true;
    setTimeout(() => {
      audioPlayEleven.value.pause();
      audioPlaySix.value.play();
      experimentSetup.value = 6;
    }, 6000);
  } else if (experimentSetup.value == 6 && chineseExperimentName.value === 1) {
    audioPlayTwo.value.pause();
    audioPlayEleven.value.pause();
    audioPlayFour.value.pause();
    audioPlayFive.value.play();
    choseNow.value = true;
    setTimeout(() => {
      experimentSetup.value = 7;
    }, 6000);
  }
};
// 切换查看的图片
const changeCheckActive = () => {
  checkBtnPicture.value = cheackBtn;
};
const changeCheck = () => {
  checkBtnPicture.value = cheackBtnActive;
};
// 显示量杯水量
const showWater = () => {
  audioPlayTen.value.play();
  setTimeout(() => {
    maskShow.value = true;
    waterShow.value = true;
  }, 800);
};
// 按压操作
const nextSetup = () => {
  if (experimentSetup.value != 6 && chineseExperimentName.value === 0) {
    return;
  } else if (experimentSetup.value != 7 && chineseExperimentName.value === 1) {
    return;
  }
  audioPlaySix.value.pause();
  choseNow.value = false;
  cupHeadDom.value.style.bottom = "0vh";
  setTimeout(() => {
    cupHeadDom.value.style.bottom = "1vh";
    choseNow.value = true;
    if (experimentSetup.value == 6 && chineseExperimentName.value === 0) {
      audioPlayEight.value.play();
      experimentSetup.value = 7;
    } else if (experimentSetup.value == 7 && chineseExperimentName.value === 1) {
      audioPlayTwelve.value.play();
      experimentSetup.value = 8;
    }
  }, 800);
};

const homeBack = () => {
  router.push({ name: "home" });
};
// 拖動的函數 無需修改
const startMoveFuntion = (e) => {
  e.preventDefault();
  const target = e.currentTarget;

  // 步骤验证逻辑（保持原样）
  if (target.getAttribute("data-steps") - 1 != experimentSetup.value) {
    ElMessage.closeAll();
    ElMessage.warning("請按照步驟操作！");
    return;
  }

  isDragging.value = true;
  experimentClassName.value = target.getAttribute("data-className");

  // 统一获取初始坐标（兼容触摸事件）
  const isTouchEvent = e.type.startsWith("touch");
  const initialX = isTouchEvent ? e.touches[0].clientX : e.clientX;
  const initialY = isTouchEvent ? e.touches[0].clientY : e.clientY;

  // 获取元素初始位置
  const rect = target.getBoundingClientRect();
  offsetX.value = initialX - rect.left;
  offsetY.value = initialY - rect.top;

  // 定位设置
  target.style.position = "fixed";
  target.style.left = `${rect.left}px`;
  target.style.top = `${rect.top}px`;
  target.style.zIndex = 9999;

  // 统一的移动处理函数
  const moveHandler = (e) => {
    if (!isDragging.value) return;

    // 阻止默认行为（重要！）
    e.preventDefault();

    // 区分触摸/鼠标事件获取坐标
    const currentX = e.touches ? e.touches[0].clientX : e.clientX;
    const currentY = e.touches ? e.touches[0].clientY : e.clientY;

    const newX = currentX - offsetX.value;
    const newY = currentY - offsetY.value;

    target.style.left = `${newX}px`;
    target.style.top = `${newY}px`;
  };

  // 统一的释放处理函数
  const upHandler = () => {
    isDragging.value = false;
    window.removeEventListener("mousemove", moveHandler);
    window.removeEventListener("touchmove", moveHandler);
    window.removeEventListener("mouseup", upHandler);
    window.removeEventListener("touchend", upHandler);
    checkDropZone();
  };

  // 添加事件监听（passive: false 允许阻止默认行为）
  window.addEventListener("mousemove", moveHandler, { passive: false });
  window.addEventListener("touchmove", moveHandler, { passive: false });
  window.addEventListener("mouseup", upHandler, { once: true });
  window.addEventListener("touchend", upHandler, { once: true });
};
const moveFuntion = (e) => {
  if (!isDragging.value) return;

  const target = document.querySelector(`.${experimentClassName.value}`);
  if (!target) return;

  // 使用视口边界（允许移出父容器）
  const newX = e.clientX - offsetX.value;
  const newY = e.clientY - offsetY.value;

  // 动态边界限制（允许部分溢出）
  const visibleArea = {
    minX: -target.offsetWidth * 0.5,
    maxX: window.innerWidth - target.offsetWidth * 0.5,
    minY: -target.offsetHeight * 0.5,
    maxY: window.innerHeight - target.offsetHeight * 0.5,
  };

  target.style.left = `${Math.max(visibleArea.minX, Math.min(newX, visibleArea.maxX))}px`;
  target.style.top = `${Math.max(visibleArea.minY, Math.min(newY, visibleArea.maxY))}px`;
};
const endMoveFuntion = () => {
  isDragging.value = false;

  // 移除全局事件
  window.removeEventListener("mousemove", moveFuntion);
  window.removeEventListener("mouseup", endMoveFuntion);
  window.removeEventListener("touchmove", moveFuntion);
  window.removeEventListener("touchend", endMoveFuntion);

  // 检查是否拖入目标区域
  checkDropZone();
};
const checkDropZone = () => {
  let dropZone = null;
  if (experimentSetup.value != 5) {
    dropZone = document.querySelector(".frame");
  } else if (experimentSetup.value == 5) {
    dropZone = document.querySelector(".experimentBox");
  }
  const target = document.querySelector(`.${experimentClassName.value}`);

  console.log(target);

  if (!dropZone || !target) {
    console.error("未找到目标区域或拖动元素");
    return;
  }

  // 获取边界矩形
  const targetRect = target.getBoundingClientRect();
  const dropRect = dropZone.getBoundingClientRect();

  // 碰撞检测
  if (targetRect.left < dropRect.right && targetRect.right > dropRect.left && targetRect.top < dropRect.bottom && targetRect.bottom > dropRect.top) {
    mouseEnterFunction();
  }
};

onMounted(async () => {
  initPage();
  if (chineseExperimentName.value === 0) {
    await audioPlaySeven.value.play();
    timer.value = setTimeout(async () => {
      await audioPlayNine.value.play();
    }, 3000);
  } else {
    await audioPlayNine.value.play();
  }
});
</script>
<style scoped lang="scss">
.banner {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  position: relative;
  background-image: url(../assets/img/experiment/background.png);
  background-size: 100% 100%;
  overflow: hidden;
  .title {
    position: absolute;
    top: 1vh;
    left: 7vw;
    width: 84vw;
    height: 22vh;
    font-size: 2vw;
    line-height: 12vh;
    color: #0081cd;
    box-sizing: border-box;
    padding-left: 9vw;
    padding-top: 7vh;
    background-image: url(../assets/img/experiment/tipsBackground.png);
    background-size: 100% 100%;
  }
  .itemBox {
    position: relative !important;
    top: 22vh;
    left: 3.4vw;
    width: 27.6vw;
    height: 69vh;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    box-sizing: border-box;
    background-image: url(../assets/img/experiment/experimentItemBackground.png);
    background-size: 100% 100%;
    .item {
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      transition: none !important; /* 禁用动画干扰 */
      transform: none !important; /* 清除可能存在的变换 */
      img {
        width: 200px;
      }
      p {
        text-align: center;
        padding: 2px 24px;
        border-radius: 16px;
        margin: 0px;
        width: max-content;
        margin: 0 auto;
        margin-top: 5px;
        font-size: 24px;
        letter-spacing: 1px;
      }
    }
    .clock {
      width: 9.8vw;
      height: 17vh;
      background-image: url(../assets/img/experiment/clockItemBackground.png);
      background-size: 100% 100%;
      left: 2vw;
      top: 23.5vh;
      img {
        width: 3.8vw;
        position: absolute;
        left: 1.65vw;
        top: 2.4vh;
      }
      .NumberPosition {
        position: absolute;
        left: 26.65vw;
        top: -17.6vh;
        z-index: 0;
        width: 8.3vw;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 1.2vw 1.2vw 0vw 3.28vw;
        p {
          text-align: center;
          padding: 0px;
          border-radius: 0px;
          margin: 0px;
          width: -moz-max-content;
          width: max-content;
          margin: 0;
          margin-top: 0px;
          font-size: 1vw;
          letter-spacing: 1px;
        }
      }
    }
    .soil01 {
      width: 12vw;
      height: 20vh;
      left: 14.2vw;
      top: 46.5vh;
      background-image: url(../assets/img/experiment/rulerBackground01.png);
      background-size: 100% 100%;
      img {
        width: 4.5vw;
        position: absolute;
        left: 3.5vw;
        top: 2vh;
      }
    }
    .soil02 {
      width: 11.9vw;
      height: 20vh;
      left: 14vw;
      top: 46vh;
      background-image: url(../assets/img/experiment/rulerBackground02.png);
      background-size: 100% 100%;
      img {
        width: 4.5vw;
        position: absolute;
        left: 4vw;
        top: 2vh;
      }
    }
    .funnel01 {
      width: 12vw;
      height: 31vh;
      left: 1.2vw;
      top: 2.8vh;
      background-image: url(../assets/img/experiment/clampBackground.png);
      background-size: 100% 100%;
      img {
        width: 5vw;
        position: absolute;
        top: 6vh;
        left: 3.5vw;
      }
    }
    .funnel02 {
      width: 12vw;
      height: 20.1vh;
      left: 1vw;
      top: 24.2vh;
      background-image: url(../assets/img/experiment/clampBackground02.png);
      background-size: 100% 100%;
      img {
        width: 4vw;
        position: absolute;
        top: 2.4vh;
        left: 4vw;
      }
    }
    .paper01 {
      width: 12vw;
      height: 20.5vh;
      left: 14.3vw;
      top: 2.8vh;
      background-image: url(../assets/img/experiment/paperBackground.png);
      background-size: 100% 100%;
      img {
        width: 6vw;
        position: absolute;
        top: 2.5vh;
        left: 3vw;
      }
    }
    .paper02 {
      width: 12vw;
      height: 20.5vh;
      left: 13.9vw;
      top: 2.8vh;
      background-image: url(../assets/img/experiment/paperBackground02.png);
      background-size: 100% 100%;
      img {
        width: 6vw;
        position: absolute;
        top: 2.5vh;
        left: 3vw;
      }
    }
    .cardboard01 {
      width: 12vw;
      height: 20.5vh;
      left: 14.3vw;
      top: 24.8vh;
      background-image: url(../assets/img/experiment/cardboardBackground.png);
      background-size: 100% 100%;
      img {
        width: 5vw;
        position: absolute;
        top: 1.4vh;
        left: 3.5vw;
      }
    }
    .cardboard02 {
      width: 12vw;
      height: 20.5vh;
      left: 13.9vw;
      top: 23.9vh;
      background-image: url(../assets/img/experiment/cardboardBackground02.png);
      background-size: 100% 100%;
      img {
        width: 5vw;
        position: absolute;
        top: 1.4vh;
        left: 3.5vw;
      }
    }
    .facemask01 {
      width: 7.8vw;
      height: 23vh;
      top: 37.5vh;
      left: 1.2vw;
      background-image: url(../assets/img/experiment/facemaskBackground.png);
      background-size: 100% 100%;
      img {
        width: 5vw;
        position: absolute;
        left: 1.42vw;
        top: 5.5vh;
      }
    }
    .facemask02 {
      width: 11.8vw;
      height: 20.3vh;
      top: 2.5vh;
      left: 1.1vw;
      background-image: url(../assets/img/experiment/facemaskBackground02.png);
      background-size: 100% 100%;
      img {
        width: 5vw;
        position: absolute;
        left: 3.42vw;
        top: 2.5vh;
      }
    }
    .cup01 {
      width: 11.8vw;
      height: 31vh;
      left: 1.3vw;
      top: 35.5vh;
      background-image: url(../assets/img/experiment/cupBackground.png);
      background-size: 100% 100%;
      img {
        width: 2.6vw;
        position: absolute;
        top: 4vh;
        left: 4.5vw;
      }
    }
    .cup02 {
      width: 11.8vw;
      height: 20.1vh;
      left: 1vw;
      top: 46vh;
      background-image: url(../assets/img/experiment/cupBackground02.png);
      background-size: 100% 100%;
      img {
        width: 1.7vw;
        position: absolute;
        top: 2vh;
        left: 5vw;
      }
    }
    .fastBtn {
      position: absolute;
      width: 3.8vw;
      left: 38vw;
      top: 6vh;
      z-index: 1;
    }
  }
  .experimentBox {
    position: absolute;
    width: 64.7vw;
    height: 72.2vh;
    left: 32vw;
    top: 21vh;
    background-image: url(../assets/img/experiment/experimentBackground.png);
    background-size: 100% 100%;
    .frame {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
    .cupAll {
      width: 4.5vw;
      height: 26vh;
      position: absolute;
      top: 38vh;
      left: 24vw;
    }
    .borderBox {
      width: 19.2vw;
      height: 34vh;
      top: 13vh;
      left: 34.2vw;
      position: absolute;
      border: 1px dashed #666;
    }
  }
  .waterPicture {
    position: absolute;
    top: 0;
    left: 11vw;
    height: 100vh;
    z-index: 12;
  }
  .showMask {
    position: absolute;
    bottom: 20vh;
    right: 5vw;
    width: 16vw;
    z-index: 11;
  }
  .mask {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10;
    .inputBox {
      width: 31.35vw;
      height: 40.4vh;
      position: absolute;
      left: 33vw;
      top: 29vh;
      background-image: url(../assets/img/experiment/askBox.png);
      background-size: 100% 100%;
      .inputDiv {
        position: absolute;
        top: 17.4vh;
        left: 8.34vw;
        border-radius: 6px;
        width: 14.45vw;
        height: 9.2vh;
        background: transparent;
        font-size: 2.3vw;
        color: #0183c4;
        border: 1px dashed #fff;
      }
      .inputDiv:focus {
        outline: none;
      }
    }
    .sumbitBtn {
      position: absolute;
      top: 80vh;
      left: 40.5vw;
      width: 15vw;
    }
  }
  .homeBtn {
    position: absolute;
    bottom: 1vh;
    right: 1vw;
    width: 5.3vw;
  }
  .checkBtn {
    right: 12vw;
    position: absolute;
    z-index: 13;
    width: 18vw;
    bottom: 3vh;
    left: 38vw;
  }
  .arrow {
    width: 11vw;
    position: absolute;
    top: 15vh;
    left: 70.5vw;
  }
  .messageBox {
    position: absolute;
    left: 13vw;
    top: 32vh;
    width: 30vw;
    font-size: 1.5vw;
    line-height: 6vh;
    letter-spacing: 1px;
    font-family: "tips";
    color: #fff;
    background-size: 100% 100%;
    padding: 4vh 3vw 12vh;
    box-sizing: border-box;
    background-image: url(../assets/img/double/tipBackg.png);
  }
  .robot {
    position: absolute;
    top: 48vh;
    left: 0vw;
    width: 25vw;
  }
}
</style>
